import React, { useEffect, useRef, useState } from "react";
import "./about.scss";
import { useWindowSize } from "react-use";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { aboutSliderData } from "../../data/homepageData";
import {
  Drdo,
  accordOpen,
  biotech,
  counterClient,
  counterYear,
  greenLeft,
  images,
  leftblack,
  msme,
  playIcon,
  rightblack,
  science,
  whiteCircleLeft,
  whiteCircleRight,
} from "../../source";
import Counter from "../../components/Counter/Counter";
import CommonBanner from "../../components/CommonBanner/CommonBanner";
import { milestoneData, teamData } from "../../data/data";
import { aboutURL } from "../../helpers/paths";
import FsLightbox from "fslightbox-react";

const mediadata = [
  {
    id: 1,
    type: "video",
    img: images.startupHanshakeThumnail.image,
    alt: "Startup Hanshake",
    link: "https://www.youtube.com/embed/q51DdoG9RrQ?si=gwcwP-FFCI9cakha",
  },
  {
    id: 2,
    linkType: "external",
    img: images.indiaToday.image,
    alt: "india today",
    link: "https://www.indiatoday.in/education-today/news/story/iit-madras-incubated-start-up-kapindra-develops-novel-diamond-coatings-1645041-2020-02-10",
    title: "India Today",
  },
  {
    id: 3,
    linkType: "external",
    img: images.hindustanTimes.image,
    alt: "hindustan times",
    link: "https://www.hindustantimes.com/education/iit-madras-incubated-start-up-develops-diamond-coatings/story-aG9lXfnAGnbg8Y55klZOpK.html",
    title: "Hindustan Times",
  },
  {
    id: 4,
    linkType: "external",
    img: images.indianExpress.image,
    alt: "indian express",
    link: "https://www.newindianexpress.com/cities/chennai/2020/Feb/11/start-up-uses-diamond-to-help-hypersonic-missile-re-entry-2101670.html",
    title: "The New Indian Express",
  },
  // {
  //   id: 5,
  //   img: biotech,
  //   alt: "Biotech",
  // },
];

const About = () => {
  const { width } = useWindowSize();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [vidLink, setVidLink] = useState("");
  // const [containerMargin, setcontainerMargin] = useState(0);
  // const containerRef = useRef(null);

  const aboutSliderList = aboutSliderData.map((item, i) => (
    <SwiperSlide key={i}>
      <div className="about_img_wrapper">
        <img src={item.img} alt={item.alt} className="about_slider_img" />
      </div>
    </SwiperSlide>
  ));

  const milestoneList = milestoneData.map((data, i) => (
    <SwiperSlide key={`milestone-${i}`}>
      <div className="milestone_box">
        <div className="top_bar">
          <span className="border_line" />
          <span className="dot" />
        </div>
        <h6 className="year">{data.year}</h6>
        <p className="desc" dangerouslySetInnerHTML={{ __html: data.desc }} />
      </div>
    </SwiperSlide>
  ));

  // const teamList = teamData.map((data, i) => (
  //   <SwiperSlide key={`team-${i}`}>
  //     <div className="team_box">
  //       <img
  //         width={470}
  //         height={469}
  //         src={data.img}
  //         alt="team member"
  //         className="team_img"
  //         loading="lazy"
  //       />
  //       <h6 className="name">{data.name}</h6>
  //       <p className="desg" dangerouslySetInnerHTML={{ __html: data.desg }} />
  //     </div>
  //   </SwiperSlide>
  // ));

  // useEffect(() => {
  //   setcontainerMargin(containerRef.current.getBoundingClientRect().left);
  //   console.log(containerRef.current.getBoundingClientRect().left);
  // }, [containerRef]);

  const mediaList = mediadata.map((item, i) => (
    <SwiperSlide key={`Media-${i}`}>
      {item.type === "video" ? (
        <div
          className="video_wrapper"
          onClick={() => handleWatchClick(item.link)}
        >
          <img
            width={306}
            height={127}
            src={item.img}
            alt={item.alt}
            className="video_img"
            loading="lazy"
          />
          <img
            width={36}
            height={36}
            src={playIcon}
            alt="Play Icon"
            className="play_icon"
            loading="lazy"
          />
        </div>
      ) : item.linkType === "external" ? (
        <a href={item.link} target="_blank" rel="noreferrer">
          <div className="img_wrapper">
            <img
              width={306}
              height={127}
              src={item.img}
              alt={item.alt}
              className="media_img"
              loading="lazy"
            />
            {item.title && <h2 className="title">{item.title}</h2>}
          </div>
        </a>
      ) : (
        <div className="img_wrapper">
          <img
            width={306}
            height={127}
            src={item.img}
            alt={item.alt}
            className="media_img"
            loading="lazy"
          />
        </div>
      )}
    </SwiperSlide>
  ));

  const handleWatchClick = (videoLink) => {
    setIsVideoModalOpen(!isVideoModalOpen);
    setVidLink(videoLink);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CommonBanner link={aboutURL} text="About Us" title="About Us" />
      <section className="about_sec1" data-aos="fade">
        <div className="my_container">
          <div className="row about_row mx-auto">
            <div className="col-lg-6 about_col p-0">
              <div className="about_slider_wrapper">
                {width <= 767 ? (
                  <h2 className="heading">
                    Diamond Coatings for a Sustainable Future
                  </h2>
                ) : null}
                <Swiper
                  spaceBetween={0}
                  loop={true}
                  modules={[Navigation, Autoplay]}
                  // autoplay={{
                  //   delay: 2000,
                  //   disableOnInteraction: false,
                  // }}
                  navigation={{
                    prevEl: ".about_prev",
                    nextEl: ".about_next",
                  }}
                  className="about_swiper"
                >
                  {aboutSliderList}
                </Swiper>
                {aboutSliderData.length > 1 && (
                  <div className="about_arrow">
                    <img
                      src={width > 991 ? whiteCircleLeft : greenLeft}
                      alt="left arrow"
                      className="about_prev"
                    />
                    <img
                      src={width > 991 ? whiteCircleRight : accordOpen}
                      alt="right arrow"
                      className="about_next"
                    />
                  </div>
                )}
              </div>
              <div className=""></div>
            </div>
            <div className="col-lg-6 about_col p-0">
              <div className="about_content_wrapper">
                {width > 767 ? (
                  <h2 className="heading">
                    Diamond Coatings for a Sustainable Future
                  </h2>
                ) : null}
                <p className="subheading">
                  Kapindra is an Indian company that uses cutting-edge chemical
                  vapor deposition (CVD) technology to create innovative,
                  sustainable diamond-based products.
                </p>
                <p className="desc">
                  <strong>Innovative Wastewater Treatment Solutions</strong>{" "}
                  <br />
                  <br />
                  At Kapindra, we seamlessly blend industrial innovation with a
                  mission to enhance the quality of life. Recognizing the
                  transformative potential of Boron-Doped Diamond (BDD)
                  electrodes, we have spearheaded the development of cutting-
                  edge water disinfection solutions. Our flagship product,
                  Diamist, is a portable and efficient water disinfection device
                  powered by advanced BDD technology. Complementing this, we
                  have designed state-of-the-art ozone generators incorporating
                  BDD electrodes and ion exchange membranes, delivering highly
                  effective disinfection solutions for industrial and research
                  applications.
                  <br />
                  <br />
                  By leveraging our pioneering technologies, Kapindra is shaping
                  the future of cleaner, safer, and more sustainable water
                  systems.
                </p>
                {/* <div className="ticker_container">
                  <div className="ticker_details">
                    <Counter
                      startCount={0}
                      endCount={20}
                      duration={1.5}
                      countTitle="Years of Experience"
                      plus
                      // aboveThousand
                    />
                    <img
                      src={counterYear}
                      alt="year of experience"
                      className="ticker_img"
                    />
                  </div>
                  <div className="ticker_details">
                    <Counter
                      startCount={0}
                      endCount={15}
                      duration={1.5}
                      countTitle="Clients"
                      plus
                      // aboveThousand
                    />
                    <img
                      src={counterClient}
                      alt="clients"
                      className="ticker_img"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about_sec2" data-aos="fade-up">
        <div className="my_container">
          <div className="text_container">
            <h3 className="heading">Our Milestones</h3>
            {/* <p className="desc">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim
              ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat.
            </p> */}
          </div>
          <div className="milestone_slider">
            <Swiper
              spaceBetween={0}
              slidesPerView={4}
              speed={500}
              loop={true}
              modules={[Navigation, Autoplay]}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              navigation={{
                prevEl: ".mile_prev",
                nextEl: ".mile_next",
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                600: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 4,
                },
              }}
            >
              {milestoneList}
            </Swiper>
            <div className="mile_arrow">
              <img src={leftblack} alt="left arrow" className="mile_prev" />
              <img src={rightblack} alt="right arrow" className="mile_next" />
            </div>
          </div>
        </div>
      </section>

      <section className="about_sec3">
        <div className="my_container">
          <h3 className="heading" data-aos="fade-up">
            Media Coverage
          </h3>
          {/* <p className="desc" data-aos="fade-up">
            Explore our comprehensive list of certifications and recognitions
            awarded by various government bodies, showcasing our commitment to
            excellence and adherence to high standards.
          </p> */}

          {/* <div className="recognitions_img_wrapper" data-aos="fade-up">
            <img
              width={306}
              height={127}
              src={Drdo}
              alt="Drdo"
              className="recog_img"
              loading="lazy"
            />
            <img
              width={306}
              height={127}
              src={msme}
              alt="msme"
              className="recog_img"
              loading="lazy"
            />
            <img
              width={306}
              height={127}
              src={science}
              alt="science"
              className="recog_img"
              loading="lazy"
            />
            <img
              width={306}
              height={127}
              src={biotech}
              alt="biotech"
              className="recog_img"
              loading="lazy"
            />
          </div> */}

          <div className="media_slider_container">
            <Swiper
              modules={[Autoplay]}
              slidesPerView={4}
              spaceBetween={138}
              grabCursor={true}
              loop={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 60,
                },
                993: {
                  slidesPerView: 3,
                  spaceBetween: 75,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 50,
                },
                1200: {
                  spaceBetween: 90,
                },
                1600: {
                  spaceBetween: 110,
                },
                1920: {
                  spaceBetween: 138,
                },
              }}
            >
              {mediaList}
            </Swiper>
          </div>
        </div>
        {/* </div> */}
      </section>

      {/* <section className="about_sec4">
        <div ref={containerRef} className="my_container">
          <div className="text_container">
            <h4 className="heading" data-aos="fade-up">
              Our People
            </h4>
          </div>
        </div>
        <div className="team_slider" style={{ marginLeft: containerMargin }}>
          <Swiper
            spaceBetween={40}
            slidesPerView={3.5}
            loop={true}
            speed={1000}
            modules={[Navigation, Autoplay]}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            // navigation={{
            //   prevEl: ".team_prev",
            //   nextEl: ".team_next",
            // }}
            breakpoints={{
              0: {
                slidesPerView: 1.25,
                spaceBetween: 20,
              },
              600: {
                slidesPerView: 2.25,
              },
              992: {
                slidesPerView: 3.5,
              },
            }}
          >
            {teamList}
          </Swiper>
          <div className="team_arrow">
              <img
                src={whiteCircleLeft}
                alt="left arrow"
                className="team_prev"
              />
              <img
                src={whiteCircleRight}
                alt="right arrow"
                className="team_next"
              />
            </div>
        </div>
      </section> */}

      <section className="about_lightbox_wrapper">
        <FsLightbox toggler={isVideoModalOpen} sources={[vidLink]} />
      </section>
    </>
  );
};

export default About;
